import { cn } from '@repo/ui/lib/cn';
import * as React from 'react';

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

const EmptyState = React.forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ icon, title, description, action, className }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'flex flex-col items-center justify-center py-12 text-center',
          className,
        )}
      >
        {icon && <div className="bg-accent mb-4 rounded-full p-4">{icon}</div>}
        <h3 className="text-foreground text-lg font-semibold">{title}</h3>
        {description && (
          <p className="text-muted-foreground mt-2 max-w-sm">{description}</p>
        )}
        {action && <div className="mt-6">{action}</div>}
      </div>
    );
  },
);
EmptyState.displayName = 'EmptyState';

export { EmptyState };
